import React, { memo } from 'react'
import ItemBorder from '@v4/components/common/ItemBorder'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import clsx from 'clsx'
import EditableHTML from '@v4/components/common/EditableHTML'
import Image from '@v4/components/common/Image'
import ActionButton from '@v4/components/common/Buttons/ActionButton'
import EditableContainer from '@v4/components/common/EditableContainer'
import { useItem } from './Item.hooks'

const Item = props => {
	const [
		{
			classes,
			withImage,
			image,
			text,
			textConfig,
			buttonText,
			buttonTextConfig,
			buttonLink,
			buttonAction,
			itemKey,
			group,
			textEditable,
			buttonTextEditable,
			buttonTextKey,
			textKey,
			alignment,
		},
		{ handleImageClick, handleTextClick, handleButtonClick, handleClick, handleTextChange, handleButtonTextChange },
	] = useItem(props)

	return (
		<ItemBorder itemKey={itemKey} group={group}>
			<Box className={clsx(classes.root)} onClick={handleClick}>
				<div className={clsx(classes.content, classes[alignment], 'cta10-content')}>
					{withImage && (
						<Image
							className={clsx(classes.image, 'cta10-image')}
							onClick={handleImageClick}
							metaData={image}
						/>
					)}
					<EditableContainer
						visible={!!text}
						fieldConfig={textConfig}
						onAdd={handleTextChange}
						editable={textEditable}
						wrapper={({ children }) => (text ? children : <Box width="100%">{children}</Box>)}
					>
						<EditableHTML
							key={textKey}
							className={clsx(classes.text, 'cta10-text-block')}
							html={text}
							onClick={handleTextClick}
							editable={textEditable}
							onChange={handleTextChange}
						/>
					</EditableContainer>
					<EditableContainer
						visible={!!buttonText}
						fieldConfig={buttonTextConfig}
						onAdd={handleButtonTextChange}
						editable={buttonTextEditable}
						label="Button"
						wrapper={({ children }) => (
							<Box className={clsx(classes.buttonWrap, 'cta10-button-wrapper')}>{children}</Box>
						)}
					>
						<ActionButton
							key={buttonTextKey}
							className={clsx(classes.button, 'cta10-item-button')}
							editable={buttonTextEditable}
							onClick={handleButtonClick}
							onChange={handleButtonTextChange}
							action={buttonAction}
							href={buttonLink}
						>
							{buttonText}
						</ActionButton>
					</EditableContainer>
				</div>
			</Box>
		</ItemBorder>
	)
}

Item.propTypes = {
	group: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired,
	itemKey: PropTypes.string.isRequired,
	isMobile: PropTypes.bool.isRequired,
	mobileContentAlignment: PropTypes.string.isRequired,
	mobileButtonWidth: PropTypes.string.isRequired,
}

export default memo(Item)
